export const HOME = {
  emergentLink: 'emergent-link',
};

export const LANDING = {
  dinerBtn: 'landing-diner-role-button',
  vendorBtn: 'landing-vendor-role-button',
  adminBtn: 'landing-admin-role-button',
  heroSearchInput: 'landing-hero-search-input',
  heroSearchBtn: 'landing-hero-search-btn',
  googleAuthBtn: 'landing-google-auth-btn',
  guestBtn: 'landing-browse-as-guest-btn',
  offerCard: 'landing-offer-card',
  seeAllOffersBtn: 'landing-see-all-offers-btn',
  vendorCtaBtn: 'landing-vendor-cta-btn',
  finalCtaBtn: 'landing-final-cta-btn',
  cravingChip: 'landing-craving-chip',
};

export const AUTH = {
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  nameInput: 'auth-name-input',
  submitBtn: 'auth-submit-button',
  loginLink: 'auth-login-link',
  registerLink: 'auth-register-link',
  errorMsg: 'auth-error-message',
};

export const DINER = {
  searchInput: 'diner-search-input',
  navDiscover: 'diner-nav-discover',
  navOffers: 'diner-nav-offers',
  navScan: 'diner-nav-scan',
  navSaved: 'diner-nav-saved',
  navProfile: 'diner-nav-profile',
  restaurantCard: 'restaurant-card',
  offerCard: 'offer-card',
  saveBtn: 'save-restaurant-button',
  qrStartBtn: 'qr-scan-start-button',
  logoutBtn: 'diner-logout-button',
};

export const VENDOR = {
  navDashboard: 'vendor-nav-dashboard',
  navOffers: 'vendor-nav-offers',
  navAnalytics: 'vendor-nav-analytics',
  navWallet: 'vendor-nav-wallet',
  navProfile: 'vendor-nav-profile',
  addOfferBtn: 'vendor-add-offer-button',
  csvUploadBtn: 'vendor-csv-upload-button',
  walletCredits: 'vendor-wallet-credits',
};

export const ADMIN = {
  usersTable: 'admin-users-table',
  statsCard: 'admin-stats-card',
  cmsEditor: 'admin-cms-editor',
  savePolicyBtn: 'admin-save-policy-button',
};
